import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles.css";

// Thème choisi par l'utilisateur (sinon celui du téléphone).
try {
  const theme = localStorage.getItem("tp:pref:theme");
  const parsed = theme ? (JSON.parse(theme) as string) : "system";
  if (parsed === "light" || parsed === "dark") document.documentElement.dataset.theme = parsed;
} catch {
  /* rien */
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
